import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _079bb9cc = () => interopDefault(import('../../../pages/contact/index.vue' /* webpackChunkName: "pages/contact/index" */))
const _6ff88352 = () => interopDefault(import('../../../pages/contact-entreprise/index.vue' /* webpackChunkName: "pages/contact-entreprise/index" */))
const _d58d4056 = () => interopDefault(import('../../../pages/contact-entreprise/confirme.vue' /* webpackChunkName: "pages/contact-entreprise/confirme" */))
const _610c41ca = () => interopDefault(import('../../../pages/contact/confirme.vue' /* webpackChunkName: "pages/contact/confirme" */))
const _5ca3b626 = () => interopDefault(import('../../../pages/quotes-requests/demande-completee.vue' /* webpackChunkName: "pages/quotes-requests/demande-completee" */))
const _36b5da56 = () => interopDefault(import('../../../pages/quotes-requests/type-de-demande.vue' /* webpackChunkName: "pages/quotes-requests/type-de-demande" */))
const _6b2ebb66 = () => interopDefault(import('../../../pages/quotes-requests/type-toiture-et-consommation-de-la-consommation-electrique-annuelle.vue' /* webpackChunkName: "pages/quotes-requests/type-toiture-et-consommation-de-la-consommation-electrique-annuelle" */))
const _0520277a = () => interopDefault(import('../../../pages/quotes-requests/vos-coordonnees.vue' /* webpackChunkName: "pages/quotes-requests/vos-coordonnees" */))
const _441399fb = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))

const _861e7d2c = () => interopDefault(import('../../../../../shared/all/page/privacy/PrivacyPage.vue' /* webpackChunkName: "" */))
const _1c6fcb10 = () => interopDefault(import('../../../../../shared/all/page/cookies/CookiesPage.vue' /* webpackChunkName: "" */))
const _cad433e4 = () => interopDefault(import('../../../../../shared/all/page/termsAndConditions/TermsAndConditionsPage.fr-be.vue' /* webpackChunkName: "" */))
const _2b1ecb13 = () => interopDefault(import('../../../../../shared/all/themes/blueflow/page/ErrorPage.vue' /* webpackChunkName: "" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/contact",
    component: _079bb9cc,
    name: "contact"
  }, {
    path: "/contact-entreprise",
    component: _6ff88352,
    name: "contact-entreprise"
  }, {
    path: "/contact-entreprise/confirme",
    component: _d58d4056,
    name: "contact-entreprise-confirme"
  }, {
    path: "/contact/confirme",
    component: _610c41ca,
    name: "contact-confirme"
  }, {
    path: "/quotes-requests/demande-completee",
    component: _5ca3b626,
    name: "quotes-requests-demande-completee"
  }, {
    path: "/quotes-requests/type-de-demande",
    component: _36b5da56,
    name: "quotes-requests-type-de-demande"
  }, {
    path: "/quotes-requests/type-toiture-et-consommation-de-la-consommation-electrique-annuelle",
    component: _6b2ebb66,
    name: "quotes-requests-type-toiture-et-consommation-de-la-consommation-electrique-annuelle"
  }, {
    path: "/quotes-requests/vos-coordonnees",
    component: _0520277a,
    name: "quotes-requests-vos-coordonnees"
  }, {
    path: "/",
    component: _441399fb,
    name: "index"
  }, {
    path: "*",
    redirect: {"path":"/"}
  }, {
    path: "/declaration-de-confidentialite",
    component: _861e7d2c,
    name: "declaration-de-confidentialite"
  }, {
    path: "/cookies",
    component: _1c6fcb10,
    name: "cookies"
  }, {
    path: "/conditions-generales",
    component: _cad433e4,
    name: "conditions-générales"
  }, {
    path: "/error",
    component: _2b1ecb13,
    name: "error"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
